import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { CRMService } from '../../services/crm.service';
import { CSEService } from '../../services/cse.service';
import { GraphService } from '../../services/graph.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { RecordLockService } from '../../services/recordlock.service';
import { UtilService } from '../../services/util.service';
import {
    CarrierLookup,
    CustomerLookup,
    QuoteOrder,
    SearchCarrier,
    SearchCarrierTeam,
    SearchCustomer,
    SearchRecordLock
} from '../../models/models';

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    standalone: false
})
export class HomeComponent implements OnInit {
    public isLoading: boolean = false;
    public quoteOrderID: number = 0;
    public externalOrderNumber: string = "";
    public isShowSyncButton: boolean = false;
    public customerCode: string = '';
    public customerName: string = '';
    public carrierSearch: string = '';
    public customerID: number = 0;
    public searchCustomer: SearchCustomer = {} as SearchCustomer;
    public carrierID: number = 0;
    public carrier: SearchCarrier = {} as SearchCarrier;
    public carrierTeamList: SearchCarrierTeam[] = [];
    public searchRecordLock: SearchRecordLock = {} as SearchRecordLock;

    customerFormGroup: UntypedFormGroup = new UntypedFormGroup({
        customerCtrl: new UntypedFormControl('')
    });

    carrierFormGroup: UntypedFormGroup = new UntypedFormGroup({
        carrierLookupMCControl: new UntypedFormControl(''),
        carrierLookupCodeControl: new UntypedFormControl(''),
        carrierLookupNameControl: new UntypedFormControl(''),
        carrierLookupDOTControl: new UntypedFormControl(''),
        carrierLookupMXControl: new UntypedFormControl(''),
        carrierLookupSCACControl: new UntypedFormControl('')
    });

    constructor(private authService: AuthService, private crmService: CRMService, private cseService: CSEService,
        public graphService: GraphService, private notificationService: NotificationService,
        private orderService: OrderService, private recordLockService: RecordLockService,
        public utilService: UtilService, private router: Router, private titleService: Title) {
        this.titleService.setTitle("Home");
    }

    ngOnInit() {
        this.searchRecordLock = {} as SearchRecordLock;
    }

    logout() {
        this.authService.signOut();
    }

    public get isLoggedIn() {
        return this.authService.authenticated;
    }

    public searchQuoteOrder(isLockCheck: boolean) {
        this.orderService.getQuoteOrderByID(this.quoteOrderID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                var order: QuoteOrder = result.resultCollection[0];
                this.externalOrderNumber = order.externalOrderNumber;
                if (isLockCheck) {
                    this.getOrderRecordLock();
                }
                else {
                    this.router.navigate(['order-entry', this.quoteOrderID]);
                }
            }
            else {
                this.notificationService.showWarning("Order Not Found. Order #" + this.externalOrderNumber, "WARNING: Order Not Found");
            }
        });
    }

    public searchExternalOrder(isLockCheck: boolean) {
        this.isShowSyncButton = false;
        this.orderService.getQuoteOrderByExternalOrderNumber(this.externalOrderNumber).subscribe(result => {
            if (result.resultCollection.length > 0) {
                var order: QuoteOrder = result.resultCollection[0];
                this.quoteOrderID = order.quoteOrderID;
                if (isLockCheck) {
                    this.getOrderRecordLock();
                }
                else {
                    this.router.navigate(['order-entry', this.quoteOrderID]);
                }
            }
            else {
                this.notificationService.showWarning("Order Not Found. Ext. Order #" + this.externalOrderNumber, "WARNING: Order Not Found");
                this.isShowSyncButton = true;
            }
        });
    }

    public syncOrder() {
        if (this.externalOrderNumber != "") {
            this.utilService.isLoading = true;
            this.orderService.syncOrder(this.externalOrderNumber).subscribe(result => {
                this.utilService.isLoading = false;
                this.isShowSyncButton = false;
                console.log("syncOrder", result);
                if (result.length > 0) {
                    this.notificationService.showSuccess("Order Successfully Synced", "SUCCESS: Sync Order");
                    this.searchExternalOrder(false);
                }
                else {
                    this.notificationService.showWarning("Sync: External Order Not Found. Ext. Order #" + this.externalOrderNumber, "WARNING: External Order Sync");
                }
            });
        }
    }

    public searchCustomerCode() {
        if (this.customerCode.length < 1) return;

        this.router.navigate(['customer-detail', this.customerCode]);
    }

    public searchCustomerName() {
        this.router.navigate(['customer-detail', this.customerName]);
    }

    public searchCarrier() {
        if (this.carrierSearch.length < 1) return;

        this.router.navigate(['carrier-detail', this.carrierSearch]);
    }

    public testGraph() {
        this.graphService.sendMessage().then((result) => {
            var ok = result;
        });
    }

    public onCustomerChange(evt: any, ctrl: string) {
        var selectedCustomer = this.customerFormGroup.controls[ctrl].value as CustomerLookup;

        this.searchCustomer = {} as SearchCustomer;
        if (!isNaN(evt) && evt != null) {
            this.customerID = evt;
        }
        else {
            this.customerID = selectedCustomer.customerID;
        }
        this.getCustomer(this.customerID);
            //this.getCustomerNotes(this.billToID, "billto");
        //console.log("home:onCustomerChange", evt, ctrl, this.customerID);
    }

    private getCustomer(customerID: number) {
        this.crmService.getSearchCustomerByID(customerID).subscribe(result => {
            var cust: SearchCustomer = result.resultCollection[0];
            this.searchCustomer = Object.assign({}, cust);
        });
    }

    public showMapPoint(lat: number, lon: number) {
        //this.notificationService.showWarning("Customer map not yet implmented.", "Not Implemented.");
        //var url: string = "https://bing.com/maps/default.aspx?cp=" + lat + "~" + lon;
        var url: string = "https://bing.com/maps/default.aspx?rtp=pos." + lat + "_" + lon + "&rtop=0~1~0";
        //https://bing.com/maps/default.aspx?cp=47.677797~-122.122013
        //https://bing.com/maps/default.aspx?rtp=adr.One%20Microsoft%20Way,%20Redmond,%20WA%2098052
        //https://bing.com/maps/default.aspx?rtp=pos.45.23423_-122.1232&rtop=0~1~0
        return url;
    }

    public onCarrierChange(evt: any, lookupType: string) {
        var selectedCarrier = this.carrierFormGroup.controls['carrierLookup' + lookupType + 'Control'].value as CarrierLookup;

        if (lookupType != "MC") {
            this.carrierFormGroup.controls['carrierLookupMCControl'].setValue("");
        }
        if (lookupType != "Code") {
            this.carrierFormGroup.controls['carrierLookupCodeControl'].setValue("");
        }
        if (lookupType != "Name") {
            this.carrierFormGroup.controls['carrierLookupNameControl'].setValue("");
        }
        if (lookupType != "DOT") {
            this.carrierFormGroup.controls['carrierLookupDOTControl'].setValue("");
        }
        if (lookupType != "MX") {
            this.carrierFormGroup.controls['carrierLookupMXControl'].setValue("");
        }
        if (lookupType != "SCAC") {
            this.carrierFormGroup.controls['carrierLookupSCACControl'].setValue("");
        }

        var carrierID: number = 0;
        if (!isNaN(evt) && evt != null) {
            carrierID = evt;
        }
        else {
            carrierID = selectedCarrier.carrierID;
        }
        this.carrierID = carrierID;
        //console.log("home:onCarrierChange", evt, lookupType, carrierID, selectedCarrier);

        this.utilService.isLoading = true;
        this.cseService.getSearchCarrierByCarrierID(carrierID).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0 && result.resultCollection[0] != null) {
                this.carrier = result.resultCollection[0];
                this.getCarrierTeam();
            }
            else {
                this.carrierID = 0;
                this.carrier = {} as SearchCarrier;
                this.carrierTeamList = [];
            }
            //console.log("onCarrierChange", this.carrier, result);
        });
    }

    private getCarrierTeam() {
        this.cseService.getSearchCarrierTeamByCarrierID(this.carrierID).subscribe(result => {
            this.carrierTeamList = result.resultCollection;
        });
    }

    public getOrderRecordLock() {
        this.utilService.isLoading = true;
        this.recordLockService.getSearchRecordLockByRecordTypeNameRecordID("QuoteOrder", this.quoteOrderID).subscribe(result => {
            this.utilService.isLoading = false;
            var lockList: SearchRecordLock[] = result.resultCollection;
            lockList = lockList.sort((left, right): number => {
                if (left.recordLockID > right.recordLockID) return -1;
                if (left.recordLockID < right.recordLockID) return 1;
                return 0;
            });
            var searchRecordLock = lockList.find(t => t.dateReleased == null);
            if (searchRecordLock != null) {
                this.searchRecordLock = searchRecordLock;
                //this.searchRecordLock.dateCheckedOut = this.utilService.getTimeZoneDateAsLocalDate(this.searchRecordLock.dateCheckedOut, "UTC");
            }
            else {
                this.notificationService.showSuccess("Order is not locked", "NOT LOCKED");
            }
            console.log("getOrderRecordLock", lockList, this.searchRecordLock);
        });
    }

    public overrideLock() {
        //this.recordLockService.clearRecordLock("QuoteOrder", this.searchRecordLock.recordID, this.searchRecordLock.lockSource);
        var recordTypeID = this.searchRecordLock.recordTypeID;
        var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
        this.recordLockService.overrideRecordLockByLockSource(recordTypeID, employeeID, this.searchRecordLock.recordID, this.searchRecordLock.lockSource).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.searchRecordLock = {} as SearchRecordLock;
                this.notificationService.showSuccess("Record successfully unlocked", "SUCCESS: Unlock Record");
            }
            else {
                this.notificationService.showWarning("Record could not be unlocked or is already unlocked", "WARNING: Record Not Unlocked");
            }
        });
    }

    public cancelOverride() {
        this.searchRecordLock = {} as SearchRecordLock;
    }
}
